'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$() {
}
export { $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$ as $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$ };
$c_Lapp_pages_drug\uff3frequests_CreatePageMeta$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_drug\uff3frequests_CreatePageMeta$.prototype.constructor = $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$;
/** @constructor */
function $h_Lapp_pages_drug\uff3frequests_CreatePageMeta$() {
}
export { $h_Lapp_pages_drug\uff3frequests_CreatePageMeta$ as $h_Lapp_pages_drug\uff3frequests_CreatePageMeta$ };
$h_Lapp_pages_drug\uff3frequests_CreatePageMeta$.prototype = $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$.prototype;
$c_Lapp_pages_drug\uff3frequests_CreatePageMeta$.prototype.pageTitle__Lframework_localization_LocalizationSupport$LocalizedText = (function() {
  var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedText__Lframework_localization_LocalizationSupport$LocalizedText$();
  var localize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "New Drug Request";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$2(localize, this$1);
});
var $d_Lapp_pages_drug\uff3frequests_CreatePageMeta$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_drug\uff3frequests_CreatePageMeta$, "app.pages.drug_requests.CreatePageMeta$", ({
  Lapp_pages_drug\uff3frequests_CreatePageMeta$: 1
}));
export { $d_Lapp_pages_drug\uff3frequests_CreatePageMeta$ as $d_Lapp_pages_drug\uff3frequests_CreatePageMeta$ };
var $n_Lapp_pages_drug\uff3frequests_CreatePageMeta$;
function $m_Lapp_pages_drug\uff3frequests_CreatePageMeta$() {
  if ((!$n_Lapp_pages_drug\uff3frequests_CreatePageMeta$)) {
    $n_Lapp_pages_drug\uff3frequests_CreatePageMeta$ = new $c_Lapp_pages_drug\uff3frequests_CreatePageMeta$();
  }
  return $n_Lapp_pages_drug\uff3frequests_CreatePageMeta$;
}
export { $m_Lapp_pages_drug\uff3frequests_CreatePageMeta$ as $m_Lapp_pages_drug\uff3frequests_CreatePageMeta$ };
//# sourceMappingURL=app.pages.drug_requests.-Create-Page-Meta$.js.map
